import { useEffect, useState } from 'react';
import { tradeApi } from './api.js';
import { StatusTag } from './RequestDetail.jsx';
import { typeLabels } from './fields.js';

function day(iso) {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

/** The advisor's requests: anything waiting on them first, then what is with Investment Management, then the recently closed. */
export default function MyRequests({ navigate }) {
  const [state, setState] = useState({ state: 'loading' });
  useEffect(() => {
    tradeApi.myRequests().then(res => setState(res.ok ? { state: 'ready', ...res.body } : { state: 'failed', error: res.body.error }));
  }, []);

  if (state.state === 'loading') {
    return <div className="tt-loading"><div className="load-spinner" /><p>Reading your requests from Salesforce…</p></div>;
  }
  if (state.state === 'failed') {
    return <div className="tt-page"><div className="tt-banner is-error" role="alert"><strong>Your requests could not be read.</strong> {state.error}</div></div>;
  }

  const rows = state.requests || [];
  const groups = [
    { title: 'Waiting on you', rows: rows.filter(r => r.needsInput), empty: 'Nothing is waiting on you.' },
    { title: 'With Investment Management', rows: rows.filter(r => !r.needsInput && !['Completed', 'Cancelled'].includes(r.status)), empty: 'No open requests.' },
    { title: 'Closed in the last two weeks', rows: rows.filter(r => ['Completed', 'Cancelled'].includes(r.status)), empty: 'None.' },
  ];

  return (
    <div className="tt-page">
      <header className="tt-page-head">
        <div>
          <p className="tt-kicker">Trade requests</p>
          <h1>My requests</h1>
          <p className="tt-muted">Requests you sent, and requests for households you own. New requests start from the household's Trade Requests list in Salesforce.</p>
        </div>
      </header>
      {groups.map(g => (
        <section key={g.title} className={'tt-card' + (g.title === 'Waiting on you' && g.rows.length ? ' is-attention' : '')}>
          <h2>{g.title} {g.rows.length > 0 && <span className="tt-count">{g.rows.length}</span>}</h2>
          {g.rows.length === 0 ? <p className="tt-muted">{g.empty}</p> : (
            <table className="tt-table is-rows">
              <tbody>
                {g.rows.map(r => (
                  <tr key={r.id} onClick={() => navigate(`/trade/requests/${r.id}`)}>
                    <td><a href={`/trade/requests/${r.id}`} onClick={e => { e.preventDefault(); navigate(`/trade/requests/${r.id}`); }}>{r.name}</a></td>
                    <td>{r.household}</td>
                    <td>{typeLabels(r.types)}</td>
                    <td><StatusTag status={r.status} /></td>
                    <td className="tt-muted">{day(r.lastModifiedDate)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </section>
      ))}
    </div>
  );
}
